(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vyrtse-recipe-calculator"] && !Shopify.designMode) return;
  try {
    
  class RecipeCalculator extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-recipe-calculator-input]');
      this.resetButton = this.querySelector('[data-recipe-calculator-reset]');
      this.cartButton = this.querySelector('[data-recipe-calculator-cart]');
      this.status = this.querySelector('[data-recipe-calculator-status]');
      this.cartLabel = this.querySelector('[data-recipe-calculator-cart-label]');
      this.basePortions = this.parseNumber(this.dataset.basePortions, 1);
      this.initialPortions = this.parseNumber(this.input?.value, this.basePortions);
      this.defaultCartLabel = this.cartLabel?.textContent || '';

      this.input?.addEventListener('input', () => this.updateIngredients());
      this.resetButton?.addEventListener('click', () => this.resetPortions());
      this.cartButton?.addEventListener('click', () => this.addProductsToCart());

      this.updateIngredients();
    }

    parseNumber(value, fallback) {
      const parsed = Number.parseFloat(String(value).replace(',', '.'));
      return Number.isFinite(parsed) ? parsed : fallback;
    }

    formatAmount(value, decimals) {
      const rounded = Number(value.toFixed(decimals));
      return new Intl.NumberFormat('de-DE', {
        maximumFractionDigits: decimals,
        minimumFractionDigits: 0
      }).format(rounded);
    }

    updateIngredients() {
      const portions = Math.max(this.parseNumber(this.input?.value, this.initialPortions), 0);
      const multiplier = this.basePortions > 0 ? portions / this.basePortions : 1;

      this.querySelectorAll('[data-recipe-calculator-item]').forEach((item) => {
        const baseAmount = this.parseNumber(item.dataset.amount, 0);
        const decimals = Number.parseInt(item.dataset.decimals, 10) || 0;
        const amountTarget = item.querySelector('[data-recipe-calculator-amount]');

        if (!amountTarget || baseAmount <= 0) return;

        if (item.dataset.scalable === 'true') {
          amountTarget.textContent = this.formatAmount(baseAmount * multiplier, decimals);
        } else {
          amountTarget.textContent = this.formatAmount(baseAmount, decimals);
        }
      });
    }

    resetPortions() {
      if (!this.input) return;
      this.input.value = this.initialPortions;
      this.updateIngredients();
      this.input.focus();
    }

    async addProductsToCart() {
      if (!this.cartButton) return;

      const ids = Array.from(this.querySelectorAll('[data-variant-id]'))
        .map((item) => item.dataset.variantId)
        .filter((id, index, idsList) => id && idsList.indexOf(id) === index);

      if (!ids.length) {
        this.setStatus('Keine verknuepften Produkte fuer dieses Rezept gefunden.');
        return;
      }

      this.cartButton.disabled = true;
      this.setCartLabel('Wird hinzugefuegt...');
      this.setStatus('');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: ids.map((id) => ({ id: Number(id), quantity: 1 }))
          })
        });

        if (!response.ok) throw new Error('Cart request failed');

        await this.refreshCart(true);

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

        this.setStatus('Verknuepfte Produkte wurden in den Warenkorb gelegt.');
        this.setCartLabel(this.defaultCartLabel);
      } catch (error) {
        this.setStatus('Das hat leider nicht geklappt. Bitte oeffne die Produkte einzeln.');
        this.setCartLabel(this.defaultCartLabel);
      } finally {
        this.cartButton.disabled = false;
      }
    }

    async refreshCart(openDrawer) {
      if (typeof window.refreshCart === 'function') {
        window.refreshCart(openDrawer);
        return;
      }

      const cartForm = document.getElementById('AjaxCartForm');
      const cartSubtotal = document.getElementById('AjaxCartSubtotal');

      if (!cartForm || !cartSubtotal) return;

      const response = await fetch('?section_id=helper-cart');
      if (!response.ok) return;

      const text = await response.text();
      const helperCart = new DOMParser().parseFromString(text, 'text/html');
      const updatedCartForm = helperCart.getElementById('AjaxCartForm');
      const updatedSubtotal = helperCart.getElementById('AjaxCartSubtotal');

      if (!updatedCartForm || !updatedSubtotal) return;

      cartForm.innerHTML = updatedCartForm.innerHTML;
      if (typeof cartForm.ajaxifyCartItems === 'function') {
        cartForm.ajaxifyCartItems();
      }

      document.querySelectorAll('[data-header-cart-count]').forEach((element) => {
        const count = cartForm.querySelector('[data-cart-count]');
        if (count) element.textContent = count.textContent;
      });

      document.querySelectorAll('[data-header-cart-total]').forEach((element) => {
        const total = cartForm.querySelector('[data-cart-total]');
        if (total) element.textContent = total.textContent;
      });

      cartSubtotal.innerHTML = updatedSubtotal.innerHTML;

      const cartSidebar = document.querySelector('[data-js-site-cart-sidebar]');
      if (openDrawer && cartSidebar && typeof cartSidebar.show === 'function') {
        cartSidebar.show();
      }
    }

    setStatus(message) {
      if (this.status) this.status.textContent = message;
    }

    setCartLabel(message) {
      if (this.cartLabel) this.cartLabel.textContent = message;
    }
  }

  if (!customElements.get('recipe-calculator')) {
    customElements.define('recipe-calculator', RecipeCalculator);
  }

  } catch(e) { console.error(e); }
})();
})();
